import { defineComponent, h } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';

import FormFieldset from './formFieldset.jsx';

export default defineComponent({
    name: 'sform-section',
    mixins: [BaseComponent],
    components: {
        FormFieldset
    },
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
    },
    methods: {
    },
    render() {
        if (!this.schema || !this.form)
            return null;

        return (
            <FormFieldset
                layouttype={this.layouttype}
                root={this.root}
                form={this.form}
                cmodel={this.cmodel}
                modelkey={this.modelkey}
                element={this.element}
                appearance={this.appearance}
                noinput={this.noinput}
                schema={this.schema}
                scopeitems={this.scopeitems}
                controlscope={this.controlscope}
                depth={this.depth}
                nopadding={true}
                isArrayItem={this.isArrayItem}
                nestedInTitledFieldset={this.nestedInTitledFieldset}
                columns={this.element?.ControlData?.columns}
                gridTemplateColumns={this.element?.ControlData?.gridTemplateColumns}>
            </FormFieldset>
        );
    }
});
